import { getDataWithToken } from "../api/api";
import { GET_USER_GAMES } from "./Constant";
import { getUserInfo } from "../utils/common";

const sendToUnity = (method, data) => {
    const payload = encodeURIComponent(JSON.stringify(data));
    const url = `uniwebview://callback?method=${method}&payload=${payload}`;

    window.location.href = url;
};
  
export const initUnityBridge = () => {

    window.getUserGames = async function () {
        const response = await getDataWithToken(GET_USER_GAMES);
        sendToUnity("getUserGames", response);
    };

    window.getUserData = async function () {
        const userData = getUserInfo();
        sendToUnity("getUserData", userData);
    };

    console.log("✅ UnityBridge ready");
};